import { writable, derived } from "svelte/store";
import { SearchState } from "./search-service";
import { fileStore } from "./select-files";
function createOrderStore() {
    const { subscribe, update, set } = writable({
        selectedFormat: "",
        options: {},
        values: {}
    });
    return {
        subscribe,
        setFormat: (selectedFormat, allOrderOptions) => update(() => {
            // Filter options for the selected format
            const filteredOptions = {};
            Object.entries(allOrderOptions).forEach(([key, optionsArray]) => {
                // Find option that matches this format
                const matchingOption = optionsArray.find((option) => option.formats.includes(selectedFormat));
                if (matchingOption) {
                    filteredOptions[key] = matchingOption;
                }
            });
            return {
                selectedFormat,
                options: filteredOptions,
                values: {}
            };
        }),
        setOrderValue: (optionId, orderValues) => update((state) => (Object.assign(Object.assign({}, state), { values: Object.assign(Object.assign({}, state.values), { [optionId]: orderValues }) }))),
        reset: () => set({
            selectedFormat: "",
            options: {},
            values: {}
        })
    };
}
export const orderDates = derived([SearchState, fileStore], ([$search, $files]) => {
    var _a, _b;
    return ({
        startDate: (_a = $search.params.get("startDate")) !== null && _a !== void 0 ? _a : $files.minDate,
        endDate: (_b = $search.params.get("endDate")) !== null && _b !== void 0 ? _b : $files.maxDate
    });
});
export const orderStore = createOrderStore();
function createModalStore() {
    const { subscribe, update } = writable({
        isModalOpen: false
    });
    return {
        subscribe,
        openModal: () => update(() => ({ isModalOpen: true })),
        closeModal: () => update(() => ({ isModalOpen: false }))
    };
}
export const modalStore = createModalStore();
